










import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'Produkt',
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
});
